import { getFocusableChildren, isFocusable } from "./keyboard";
export const classNames = (...clsNames) => clsNames.filter((c) => Boolean(c)).join(" ");
export const hasOverflow = (elementRect) => elementRect.scrollWidth > elementRect.clientWidth || elementRect.scrollHeight > elementRect.clientHeight;
// a valid portal target must not have a child that is focusable nor with approximately the same
// dimensions, as to not confuse the user about which element is actually focusable.
export const warnOverlappingFocusableElements = (target) => {
    if (!target || !isFocusable(target)) {
        return;
    }
    const child = getFocusableChildren(target)[0];
    if (!child) {
        return;
    }
    const targetRect = target.getBoundingClientRect();
    const childRect = child.getBoundingClientRect();
    if (isRectApproxEqual(targetRect, childRect)) {
        // NOSONAR
        console.warn("[apollo-components] The following elements have intersecting focus regions, which might confuse the user.", target, child);
    }
};
const isRectApproxEqual = (parent, child, errorMargin = 2) => Math.abs(parent.top - child.top) <= errorMargin &&
    Math.abs(parent.right - child.right) <= errorMargin &&
    Math.abs(parent.bottom - child.bottom) <= errorMargin &&
    Math.abs(parent.left - child.left) <= errorMargin;
//# sourceMappingURL=DomHelpers.js.map